const NON_EDITABLE_FILE_BANNER = "// Code generated by Prismic. DO NOT EDIT.";
export {
  NON_EDITABLE_FILE_BANNER
};
//# sourceMappingURL=constants.js.map
